import { Box, Stack, Typography } from '@mui/material';
import type { Currency } from '@vy/types';
import { Price } from '../../../../components/design/Price';

type ValueDisplayProps = {
  label: string;
  currency: Currency;
  value: number;
};

export const ValueDisplay: React.FC<ValueDisplayProps> = ({ label, currency, value }) => (
  <Stack direction="column" sx={{
    alignItems: "center"
  }}>
    <Price className="text-[16px]" currency={currency}>
      {value}
    </Price>
    <Box sx={{
      width: "100%"
    }}>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        sx={{
          fontSize: 14,
          textAlign: "left"
        }}>
        {label}
      </Typography>
    </Box>
  </Stack>
);
